/**
 * Inheritance of Scene with a WebGL version
 * @class Scene
 * @param {HTMLElement} element
 * @constructor
 */
function Scene(element) {
	this._element = element;
}

/** @type WebGLRenderingContext */
Scene.prototype._context = null;
/** @type Boolean */
Scene.prototype._loaded = false;
/**
 * Define load state
 * @property {Boolean} loaded
 */
Object.defineProperty(Scene.prototype, "loaded", {
	/** @this {Scene} */
	get: function loaded(){
		return this._loaded;
	}
});

/**
 * Draw scene
 * @param {Number} positionX Position x (0 to 1)
 * @param {Number} positionY Position y (0 to 1)
 */
Scene.prototype.draw = function draw(positionX, positionY) {

};
/**
 * Resize scene
 * @param width
 * @param height
 */
Scene.prototype.updateSize = function updateSize(width, height) {

};

Scene.prototype._dispatchProgressEvent = function _dispatchProgressEvent(loaded, total) {
	if(typeof this.onprogress === "function"){
		loaded = loaded == undefined || loaded == null ? 0 : Number(loaded);
		total = total == undefined || total == null ? 0 : Number(total);
		this.onprogress({
			type: "progress",
			currentTarget: this,
			lengthComputable: total != 0,
			loaded: loaded,
			total: total
		});
	}
};
Scene.prototype._dispatchLoadEvent = function _dispatchLoadEvent() {
	if (typeof this.onload === "function"){
		this.onload({
			type: "load",
			currentTarget: this
		});
	}
};
Scene.prototype._dispatchErrorEvent = function _dispatchErrorEvent() {
	if (typeof this.onerror === "function"){
		this.onerror({
			type: "error",
			currentTarget: this
		});
	}
};
Scene.prototype._dispatchAbortEvent = function _dispatchAbortEvent() {
	if (typeof this.onabort === "function"){
		this.onabort({
			type: "abort",
			currentTarget: this
		});
	}
};

/**
 * Will remove all listeners and cancel all frame requests
 */
Scene.prototype.clear = function clear(){

};